import React from 'react'
import { AppVideoPlayer } from 'components/Common/AppVideoPlayer/AppVideoPlayer.component'

interface IAppCombinedVideoCard {
  videoTitle: string
  videoUrl: string
  stepsCovered: number[]
}

export const AppCombinedVideoCard: React.FC<IAppCombinedVideoCard> = ({
  videoTitle,
  videoUrl,
  stepsCovered,
}) => {
  // Format steps range (e.g., "1 → 3" or just "1, 3, 5" if non-consecutive)
  const formatStepsRange = (steps: number[]) => {
    if (steps.length === 0) return ''
    if (steps.length === 1) return `STEP ${steps[0]}`

    const sortedSteps = [...steps].sort((a, b) => a - b)
    const isConsecutive = sortedSteps.every((step, i) => i === 0 || step === sortedSteps[i - 1] + 1)

    if (isConsecutive && sortedSteps.length > 1) {
      return `STEPS ${sortedSteps[0]} → ${sortedSteps[sortedSteps.length - 1]}`
    }

    return `STEPS ${sortedSteps.join(', ')}`
  }

  const stepsLabel = formatStepsRange(stepsCovered)

  return (
    <div className="space-y-3">
      {/* Header with title and steps badge - badge on far right */}
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-sm font-semibold text-app-black-100 font-inter">{videoTitle}</h2>
        {/* Steps badge - only show if more than one step is covered */}
        {stepsCovered.length > 1 && (
          <div className="flex-shrink-0 bg-[#705AF8] text-white px-2.5 py-0.5 rounded-lg text-[11px] font-bold font-inter whitespace-nowrap">
            {stepsLabel}
          </div>
        )}
      </div>

      {/* Video player */}
      <div className="rounded-lg overflow-hidden">
        <AppVideoPlayer url={videoUrl} />
      </div>
    </div>
  )
}
